// #region imports

// --- Angular
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { geteuid } from 'process';

// #endregion

@Component({
  selector: 'hs-registered',
  templateUrl: './registered.component.html',
  styleUrls: ['./registered.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisteredComponent implements OnInit {
  @Input() emailAddress: string;
  @Input() isRegistered: boolean;

  @Output() resend = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {

    var randomguid = this.uuidv4().replace("-", "");

    (<any>window).Intercom("boot", {
      app_id: "m7san35s",
      name: "There",
      email: randomguid + "@heartstyles.com",
      created_at: new Date()
    });
  }

  getRandomEmail() {
    let result = '';
    for (var i = 0; i < 5; i++) {
      result += String.fromCharCode(Math.floor(Math.random() * 25) + 97);
    }
    return result + '@heartstyles.com';
  }

  onResend(e: any) {
    e.preventDefault();
    this.resend.emit(this.emailAddress);
  }

  uuidv4() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);

      return v.toString(16);
    });
  }
}
